import { TechAssetType } from "../../../../shared/enums/tech-asset-type";
import { ITechAssetsDto, ITechAssetWithRelationsDto } from "../dtos/tech-assets";

export class TechAsset {
  readonly id: string;
  name: string;
  techTypeName: string;
  importTechBrand: string;
  techModel: string;
  stateNumber: string;
  inventoryNumber: string;
  techFactoryNum: string;
  techEngineNum: string;
  importFarmName: string;
  techOwner: string;
  category: TechAssetType;
  isDeleted?: boolean;

  constructor(id: string) {
    this.id = id;
  }

  get asDto(): ITechAssetsDto {
    return {
      id: this.id,
      name: this.name,
      techTypeName: this.techTypeName,
      importTechBrand: this.importTechBrand,
      techModel: this.techModel,
      stateNumber: this.stateNumber,
      inventoryNumber: this.inventoryNumber,
      techFactoryNum: this.techFactoryNum,
      techEngineNum: this.techEngineNum,
      importFarmName: this.importFarmName,
      techOwner: this.techOwner,
      category: this.category,
      isDeleted: this.isDeleted,
    };
  }

  updateFromDto(dto: ITechAssetsDto): void {
    this.name = dto.name;
    this.techTypeName = dto.techTypeName ?? dto.techTypeName ?? "";
    this.importTechBrand = dto.brandName ?? dto.importTechBrand ?? "";
    this.techModel = dto.modelName ?? dto.techModel ?? "";
    this.stateNumber = dto.stateNumber ?? "";
    this.inventoryNumber = dto.inventoryNumber ?? "";
    this.techFactoryNum = dto.factoryNumber ?? dto.techFactoryNum ?? "";
    this.techEngineNum = dto.engineNumber ?? dto.techEngineNum ?? "";
    this.importFarmName = dto.farmName ?? dto.importFarmName ?? "";
    this.techOwner = dto.ownerName ?? dto.techOwner ?? "";
    this.category = dto.category;
    this.isDeleted = dto.isDeleted;
  }
}

export class TechAssetWithRelations extends TechAsset {
  farms: Set<string>;
  techOperationSubGroups: Set<string>;

  updateFromDto(dto: ITechAssetWithRelationsDto): void {
    super.updateFromDto(dto);

    this.farms = new Set(dto.farmId ? [dto.farmId] : []);
    this.techOperationSubGroups = new Set(dto.techOperationSubGroupIds ?? []);
  }
}
